import { type ReactElement } from 'react';
import { ProjectBadge } from '@/features/projects/components/ProjectBadge';
import { OverflowTooltip } from '@/ui/composites/table/cells/OverflowTooltip';
import { Box, Text } from '@/ui/primitives';
import {
  tableV2ProjectCellFrameSx,
  tableV2ProjectCellTextSx,
  tableV2ProjectCellTooltipTextSx,
  tableV2ProjectCellTooltipTitleFrameSx,
  tableV2ProjectCellTooltipWrapperSx,
} from './TableV2MetadataCell.styles';
import type { ProjectDto } from '@flowqa/shared';

type TableV2ProjectCellProps = {
  project: Pick<ProjectDto, 'badgeChars' | 'badgeColor' | 'badgeEnabled' | 'name'> | null;
  fallbackName?: string | null;
};

export const TableV2ProjectCell = ({
  fallbackName = null,
  project,
}: TableV2ProjectCellProps): ReactElement => {
  const projectName = project?.name ?? fallbackName ?? '-';
  const projectBadge =
    project?.badgeEnabled === true ? (
      <ProjectBadge chars={project.badgeChars} color={project.badgeColor} size="compact" />
    ) : null;
  const tooltipTitle = (
    <Box component="span" sx={tableV2ProjectCellTooltipTitleFrameSx}>
      {projectBadge}
      <Text role="body" component="span" sx={tableV2ProjectCellTooltipTextSx}>
        {projectName}
      </Text>
    </Box>
  );

  return (
    <Box sx={tableV2ProjectCellFrameSx}>
      {projectBadge}
      <OverflowTooltip title={tooltipTitle} wrapperSx={tableV2ProjectCellTooltipWrapperSx}>
        <Text role="body" color="textSecondary" component="span" sx={tableV2ProjectCellTextSx}>
          {projectName}
        </Text>
      </OverflowTooltip>
    </Box>
  );
};
